export default __webpack_public_path__ + "static/product-1-0f99a1d207f6baeb3717191e077a999c.jpg";